import { ForwardedRef, forwardRef, PropsWithChildren } from 'react'
import { PositionRange } from '../../types'
import { useVisiblePositionPercent } from '../hooks/useVisiblePositionPercent'
import './ChannelsSelection.scss'
import classNames from 'classnames'

interface Props extends PropsWithChildren {
  range: PositionRange
  className?: string
}

export const ChannelsSelection = forwardRef(
  ({ range, className, children }: Props, ref: ForwardedRef<HTMLDivElement>) => {
    const left = useVisiblePositionPercent(range[0])
    const width = useVisiblePositionPercent(range[1]) - left

    return (
      <div
        className={classNames('ChannelsSelection', className)}
        style={{ left: `${left}%`, width: `${width}%` }}
        ref={ref}
      >
        {children}
      </div>
    )
  },
)
